"use client";
import { jsx as r } from "react/jsx-runtime";
import * as e from "@radix-ui/react-label";
import * as i from "react";
import { cn as m } from "./index15.js";
const s = i.forwardRef(({ className: o, ...t }, a) => /* @__PURE__ */ r(
  e.Root,
  {
    ref: a,
    className: m(
      "text-sm font-medium leading-none text-text peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      o
    ),
    ...t
  }
));
s.displayName = e.Root.displayName;
export {
  s as Label
};
//# sourceMappingURL=index11.js.map
